<div class="flex flex-col items-center justify-center h-screen bg-gray-50 p-4">
  <div class="flex flex-col items-center max-w-2xl w-full">
    @if (isLoading()) {
      <div class="flex flex-col items-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
        <p class="text-gray-600 text-lg font-semibold">Setting up your portal access…</p>
      </div>
    }

    @if (showPortalSelector()) {
      @if (contextService.getContext(); as context) {
        <lr-portal-selector [context]="context" (selectedPortal)="onPortalSelected($event)"> </lr-portal-selector>
      }
    }

    @if (errorMessage()) {
      <div class="bg-red-50 border-2 border-red-400 rounded-lg p-6 w-full mt-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3 flex-1">
            <h3 class="text-red-800 font-semibold text-lg mb-2">Authentication Error</h3>
            <p class="text-red-700 text-sm whitespace-pre-wrap">{{ errorMessage() }}</p>
          </div>
        </div>
        <div class="mt-4">
          <button
            (click)="retryLogin()"
            class="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-md transition-colors">
            Try Again
          </button>
        </div>
      </div>
    }
  </div>
</div>
